/* tslint:disable */
/* eslint-disable */

/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    AutosaveRequest,
    BrandEnum,
    CarModelVehicleType,
    ConfirmVerificationRequest,
    DriverProvisionalRegistrationCreateAccountRequest,
    DriverProvisionalRegistrationCreateAccountResponse,
    DriverProvisionalRegistrationGetPhoneRequest,
    DriverProvisionalRegistrationGetPhoneResponse,
    DriverProvisionalRegistrationStartRegistrationRequest,
    DriverProvisionalRegistrationStartRegistrationResponse,
    DriverProvisionalRegistrationStartVerificationRequest,
    DriverProvisionalRegistrationStartVerificationResponse,
    DriverVisitorExperimentParametersResponse,
    ExperimentParameters,
    GetAddressDetailsResponse,
    GetAllCountriesResponse,
    GetCommonTranslationsResponse,
    GetDocumentCaptureModeResponse,
    GetDocumentsResultsResponse,
    GetDriverRegistrationStatusResponse,
    GetFieldsResponse,
    GetFormDataForRiderUserResponse,
    GetSupportedLanguagesResponse,
    GetVehicleMakesResponse,
    GetVehicleModelsResponse,
    LiveChatToken,
    RecordApiDurationRequest,
    SearchAddressRequest,
    SearchAddressResponse,
    SignupRequest,
    StartRegistrationForRiderUserBody,
    StartRegistrationForRiderUserResponse,
    SubmitSectionFormRequest,
    TaxIdentificationNumberFormatsResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface Autosave2Request {
    hash: string;
    language?: string;
}
export interface CreateAccountRequest {
    version: string;
    deviceId: string;
    device_name: string;
    device_os_version: string;
    language: string;
    device_type?: string;
    visitor_id?: string;
}
export interface GetAddressDetailsRequest {
    hash: string;
    field_key: string;
    place_id: string;
    language?: string;
}
export interface GetAllCountriesRequest {
    language?: string;
}
export interface GetCommonTranslationsRequest {
    language?: string;
    country?: string;
}
export interface GetDocumentCaptureModeRequest {
    hash: string;
    app_version?: string;
}
export interface GetDocumentsResultsRequest {
    hash: string;
    language?: string;
}
export interface GetDriverRegistrationStatusRequest {
    hash: string;
    language?: string;
}
export interface GetDriverVisitorExperimentsRequest {
    event_key: string;
    language?: string;
    visitor_id: string;
    country_code?: string;
    city_id?: number;
}
export interface GetExperimentParametersRequest {
    hash: string;
    event_key: string;
    language?: string;
}
export interface GetExperimentParametersBeforeSignupRequest {
    brand?: BrandEnum;
    event_key: string;
    identifier: string;
    city_id: number;
    country_code: string;
    language?: string;
    enroll_to_mixpanel?: boolean;
}
export interface GetFieldsRequest {
    hash: string;
    language?: string;
    app_version?: string;
}
export interface GetFormDataForRiderUserRequest {
    rider_user_uuid: string;
    language?: string;
}
export interface GetSupportedLanguagesRequest {
    country?: string;
}
export interface GetVehicleMakesRequest {
    vehicle_type?: CarModelVehicleType;
}
export interface GetVehicleModelsByManufacturerRequest {
    manufacturerId: number;
    vehicle_type?: CarModelVehicleType;
}
export interface LiveChatGetAuthTokenRequest {
    hash: string;
}
export interface Signup2Request {
    hash: string;
    language?: string;
}
export interface StartRegistrationForRiderUserRequest {
    version: string;
    deviceId: string;
    device_name: string;
    device_os_version: string;
    language: string;
    device_type?: string;
    visitor_id?: string;
    rider_user_uuid: string;
}
export interface SubmitSectionForm2Request {
    hash: string;
    language?: string;
}
export interface ValidateDriverRegistrationDocumentsForResubmissionRequest {
    hash: string;
    language?: string;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public autosave = async (query: Autosave2Request, body: AutosaveRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/autosave',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public confirmVerification = async (body: ConfirmVerificationRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/confirmVerification',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createAccount = async (query: CreateAccountRequest, body: DriverProvisionalRegistrationCreateAccountRequest, opts?: TRequestOptions): Promise<DriverProvisionalRegistrationCreateAccountResponse>  => {
            return this.httpClient.sendRequest<DriverProvisionalRegistrationCreateAccountResponse>({
                path: '/driverRegistration/createAccount',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public getAddressDetails = async (query: GetAddressDetailsRequest, opts?: TRequestOptions): Promise<GetAddressDetailsResponse>  => {
            return this.httpClient.sendRequest<GetAddressDetailsResponse>({
                path: '/driverRegistration/getAddressDetails',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getAllCountries = async (query: GetAllCountriesRequest, opts?: TRequestOptions): Promise<GetAllCountriesResponse>  => {
            return this.httpClient.sendRequest<GetAllCountriesResponse>({
                path: '/driverRegistration/getAllCountries',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getCommonTranslations = async (query: GetCommonTranslationsRequest, opts?: TRequestOptions): Promise<GetCommonTranslationsResponse>  => {
            return this.httpClient.sendRequest<GetCommonTranslationsResponse>({
                path: '/driverRegistration/getCommonTranslations',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDocumentCaptureMode = async (query: GetDocumentCaptureModeRequest, opts?: TRequestOptions): Promise<GetDocumentCaptureModeResponse>  => {
            return this.httpClient.sendRequest<GetDocumentCaptureModeResponse>({
                path: '/driverRegistration/getDocumentCaptureMode',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDocumentsResults = async (query: GetDocumentsResultsRequest, opts?: TRequestOptions): Promise<GetDocumentsResultsResponse>  => {
            return this.httpClient.sendRequest<GetDocumentsResultsResponse>({
                path: '/driverRegistration/getDocumentsResults',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverRegistrationStatus = async (query: GetDriverRegistrationStatusRequest, opts?: TRequestOptions): Promise<GetDriverRegistrationStatusResponse>  => {
            return this.httpClient.sendRequest<GetDriverRegistrationStatusResponse>({
                path: '/driverRegistration/getDriverRegistrationStatus',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDriverVisitorExperiments = async (query: GetDriverVisitorExperimentsRequest, opts?: TRequestOptions): Promise<DriverVisitorExperimentParametersResponse>  => {
            return this.httpClient.sendRequest<DriverVisitorExperimentParametersResponse>({
                path: '/driverRegistration/getDriverVisitorExperiments',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getExperimentParameters = async (query: GetExperimentParametersRequest, opts?: TRequestOptions): Promise<ExperimentParameters>  => {
            return this.httpClient.sendRequest<ExperimentParameters>({
                path: '/driverRegistration/getExperimentParameters',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getExperimentParametersBeforeSignup = async (query: GetExperimentParametersBeforeSignupRequest, opts?: TRequestOptions): Promise<ExperimentParameters>  => {
            return this.httpClient.sendRequest<ExperimentParameters>({
                path: '/driverRegistration/getExperimentParametersBeforeSignup',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getFields = async (query: GetFieldsRequest, opts?: TRequestOptions): Promise<GetFieldsResponse>  => {
            return this.httpClient.sendRequest<GetFieldsResponse>({
                path: '/driverRegistration/getFields',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getFormDataForRiderUser = async (query: GetFormDataForRiderUserRequest, opts?: TRequestOptions): Promise<GetFormDataForRiderUserResponse>  => {
            return this.httpClient.sendRequest<GetFormDataForRiderUserResponse>({
                path: '/driverRegistration/getFormDataForRiderUser',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getRegistrationPhone = async (body: DriverProvisionalRegistrationGetPhoneRequest, opts?: TRequestOptions): Promise<DriverProvisionalRegistrationGetPhoneResponse>  => {
            return this.httpClient.sendRequest<DriverProvisionalRegistrationGetPhoneResponse>({
                path: '/driverRegistration/getRegistrationPhone',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSupportedLanguages = async (query: GetSupportedLanguagesRequest, opts?: TRequestOptions): Promise<GetSupportedLanguagesResponse>  => {
            return this.httpClient.sendRequest<GetSupportedLanguagesResponse>({
                path: '/driverRegistration/getSupportedLanguages',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getTaxIdentificationNumberFormats = async (opts?: TRequestOptions): Promise<TaxIdentificationNumberFormatsResponse>  => {
            return this.httpClient.sendRequest<TaxIdentificationNumberFormatsResponse>({
                path: '/driverRegistration/getTaxIdentificationNumberFormats',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getVehicleMakes = async (query: GetVehicleMakesRequest, opts?: TRequestOptions): Promise<GetVehicleMakesResponse>  => {
            return this.httpClient.sendRequest<GetVehicleMakesResponse>({
                path: '/driverRegistration/getVehicleMakes',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getVehicleModelsByManufacturer = async (query: GetVehicleModelsByManufacturerRequest, opts?: TRequestOptions): Promise<GetVehicleModelsResponse>  => {
            return this.httpClient.sendRequest<GetVehicleModelsResponse>({
                path: '/driverRegistration/getVehicleModelsByManufacturer',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public liveChatGetAuthToken = async (query: LiveChatGetAuthTokenRequest, opts?: TRequestOptions): Promise<LiveChatToken>  => {
            return this.httpClient.sendRequest<LiveChatToken>({
                path: '/driverRegistration/liveChat/getAuthToken',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public recordApiDuration = async (body: RecordApiDurationRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/recordApiDuration',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public searchAddress = async (body: SearchAddressRequest, opts?: TRequestOptions): Promise<SearchAddressResponse>  => {
            return this.httpClient.sendRequest<SearchAddressResponse>({
                path: '/driverRegistration/searchAddress',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public signup = async (query: Signup2Request, body: SignupRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/signup',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public startRegistration = async (body: DriverProvisionalRegistrationStartRegistrationRequest, opts?: TRequestOptions): Promise<DriverProvisionalRegistrationStartRegistrationResponse>  => {
            return this.httpClient.sendRequest<DriverProvisionalRegistrationStartRegistrationResponse>({
                path: '/driverRegistration/startRegistration',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public startRegistrationForRiderUser = async (query: StartRegistrationForRiderUserRequest, body: StartRegistrationForRiderUserBody, opts?: TRequestOptions): Promise<StartRegistrationForRiderUserResponse>  => {
            return this.httpClient.sendRequest<StartRegistrationForRiderUserResponse>({
                path: '/driverRegistration/startRegistrationForRiderUser',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public startVerification = async (body: DriverProvisionalRegistrationStartVerificationRequest, opts?: TRequestOptions): Promise<DriverProvisionalRegistrationStartVerificationResponse>  => {
            return this.httpClient.sendRequest<DriverProvisionalRegistrationStartVerificationResponse>({
                path: '/driverRegistration/startVerification',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public submitSectionForm = async (query: SubmitSectionForm2Request, body: SubmitSectionFormRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/submitSectionForm',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public validateDriverRegistrationDocumentsForResubmission = async (query: ValidateDriverRegistrationDocumentsForResubmissionRequest, body: object, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/driverRegistration/validateDriverRegistrationDocumentsForResubmission',
                service_id: 'driver-registration-portal',
                subdomain: 'driverregistration',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
